import { setStorage } from '../../../utils/auth-utils';
import ChangeLogDrawer from '../ChangeLog/ChangeLogDrawer';

export default function WhatsNewBanner({ show, handleClose, whatsNewModalContent }) {
  return (
    <ChangeLogDrawer
      show={show}
      onClose={() => {
        setStorage('weekly-banner-version', whatsNewModalContent.latestVersion);
        handleClose();
      }}
      isWhatsNew
    />
  );
}
